import { ActionTranslatableKeysShare } from "FlowBuilder/lib/actionTranslatable"

export type ShareableChannels = 'whatsapp' | 'twitter' | 'facebook' | 'linkedin' | 'bluesky' | 'native'
export type ChannelConfigType = {
translateKey: ActionTranslatableKeysShare,
title: string,
getUrl: (publicUrl: string, shareReason?: string) => string,
primaryBackground: string,
svg: JSX.Element
}

function getShareReason(publicUrl, shareReasonText) {
  return shareReasonText ? `${shareReasonText} ${publicUrl}` : publicUrl;
}

export const channelConfig: Record<ShareableChannels, ChannelConfigType> = {
  whatsapp: {
    translateKey: 'shareWhatsapp',
    title: 'WhatsApp',
    getUrl: (publicUrl, shareReason) => {
      return `https://wa.me/?text=${encodeURIComponent(getShareReason(publicUrl, shareReason))}`
    },
    primaryBackground: '#25D366',
    svg: <SvgIconsCircleWhatsApp />
  },
  twitter: {
    translateKey: 'shareTwitter',
    title: 'Twitter/X',
    getUrl: (publicUrl, shareReason) => {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(getShareReason(publicUrl, shareReason))}`
    },
    primaryBackground: '#111',
    svg: <SvgIconsCircleX />
  },
  facebook: {
    translateKey: 'shareFacebook',
    title: 'Facebook',
    getUrl: (publicUrl) => {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(publicUrl)}`
    },
    primaryBackground: '#0865FE',
    svg: <SvgIconsCircleFacebook />
  },
  linkedin: {
    translateKey: 'shareLinkedin',
    title: 'LinkedIn',
    getUrl: (publicUrl) => {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(publicUrl)}`
    },
    primaryBackground: '#0072B1',
    svg: <SvgIconsCircleLinkedIn />
  },
  bluesky: {
    translateKey: 'shareBluesky',
    title: 'Bluesky',
    getUrl: (publicUrl, shareReason) => {
      return `https://bsky.app/intent/compose?text=${encodeURIComponent(getShareReason(publicUrl, shareReason))}`
    },
    primaryBackground: '#3BA0FE',
    svg: <SvgIconsCircleBluesky />
  },
  native: {
    translateKey: 'shareNative',
    title: 'Native share',
    getUrl: () => '',
    primaryBackground: '#E1306C',
    svg: <SvgIconsCircleShare />
  }
}
